<script>
    import {Formly} from 'svelte-formly';
    import {getContext, onMount, tick} from "svelte";
    import imageCompression from "browser-image-compression";
    import Service from "../utils/Service";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";

    const {close} = getContext('simple-modal');

    export let model_root;
    export let application_root;
    export let mid;
    export let custom_content_type;
    export let existingContent;

    const service = new Service(model_root);

    let loaded = false;

    const form_name = 'formly_usage';
    let fields = [];

    onMount(() => {
        fetchCustomTypeDefinition();
    })

    const fetchCustomTypeDefinition = () => {
        fetch(model_root + 'admin/contents/custom_content_types/' + custom_content_type + '.js', {
            method: "GET"
        })
            .then(response => response.json())
            .then(async data => {
                let checkboxesToBeUpdated = []; // {name: xxx, value: boolean}
                let fileInputsToBeDisabled = []; // {id: xxx, files: array, multiple: boolean}
                for (let field of data) {
                    console.log(field);
                    if (typeof field.preprocess != "undefined") {
                        field.preprocess = eval(field.preprocess);
                    }
                    if (existingContent !== undefined) {
                        if (field.subtype === "boolean_checkbox") {
                            checkboxesToBeUpdated.push({
                                name: field.extra.items[0].name,
                                value: (existingContent[field.name] === true)
                            });
                        }
                        if (field.type === "input") {
                            field.value = existingContent[field.name];
                        }
                        if (field.type === "textarea") {
                            field.value = existingContent[field.name];
                        }
                        if (field.type === "file") {
                            fileInputsToBeDisabled.push({
                                id: field.name,
                                files: existingContent[field.name],
                                multiple: field.extra.multiple
                            })
                        }
                    }
                }
                fields = data;
                loaded = true;

                if (existingContent !== undefined) {
                    await tick();
                    updateBooleanCheckboxFields(checkboxesToBeUpdated);
                    await disableAndUpdateFileUploadSections(fileInputsToBeDisabled);
                }
            })
    }

    const updateBooleanCheckboxFields = (checkboxesToBeUpdated) => {
        for (let checkbox of checkboxesToBeUpdated) {
            let booleanCheckbox = document.querySelector("input.checker[name='" + checkbox.name + "']");
            if (checkbox.value) {
                booleanCheckbox.click();
            }
        }
    }

    const disableAndUpdateFileUploadSections = async (fileInputsToBeDisabled) => {
        for (let fileInput of fileInputsToBeDisabled) {
            let fileInputGroup = document.getElementById(fileInput.id).parentNode;
            for (let child of fileInputGroup.children) {
                if (child.tagName !== "LABEL") {
                    child.style.display = "none";
                }
            }

            let fileToolBoxDivContainer = document.createElement("div");
            fileToolBoxDivContainer.classList.add("container", "my-2");
            fileInputGroup.appendChild(fileToolBoxDivContainer);

            let fileToolBoxDiv = document.createElement("div");
            fileToolBoxDiv.classList.add("ccfile-list", "row", "row-cols-4");
            fileToolBoxDivContainer.appendChild(fileToolBoxDiv);

            if (Array.isArray(fileInput.files)) {
                for (let file of fileInput.files) {
                    let imageDiv = document.createElement("div");
                    imageDiv.classList.add("ccfile-list-item", "card", "me-1", "mb-2", "pt-2");

                    let imgElem = document.createElement("div");
                    imgElem.classList.add("ccfile-list-item-img", "card-img-top", "mb-1")
                    imgElem.style.backgroundImage = "url(" + application_root + "files/" + await getFilePath(file.file_id) + ")";
                    imageDiv.appendChild(imgElem)

                    let deleteBtn = document.createElement("button");
                    deleteBtn.classList.add("btn", "btn-sm", "btn-light");
                    deleteBtn.onclick = (e) => {
                        e.preventDefault();
                        removeFile(fileInput.id, file.file_id, fileInput.multiple);
                    }
                    imageDiv.appendChild(deleteBtn);

                    let deleteBtnIcon = document.createElement("i");
                    deleteBtnIcon.classList.add("far", "fa-trash-alt", "me-2");
                    deleteBtn.appendChild(deleteBtnIcon);

                    let deleteBtnText = document.createTextNode("Delete file");
                    deleteBtn.appendChild(deleteBtnText);

                    fileToolBoxDiv.appendChild(imageDiv);
                }
            }

            if (fileInput.multiple || !Array.isArray(fileInput.files) || (Array.isArray(fileInput.files) && fileInput.files.length < 1)) {
                let hiddenFileInput = document.createElement("input");
                hiddenFileInput.type = "file";
                hiddenFileInput.style.display = "none";
                hiddenFileInput.onchange = (e) => {
                    addNewFile(fileInput.id, e.target.files[0], fileInput.multiple);
                }
                fileToolBoxDiv.appendChild(hiddenFileInput);

                let uploadBtn = document.createElement("div");
                uploadBtn.ariaRoleDescription = "button";
                uploadBtn.classList.add("btn", "btn-light", "btn-sm", "border", "me-1", "mb-2", "d-flex", "align-items-center", "p-3");
                uploadBtn.addEventListener("click", () => {
                    hiddenFileInput.click();
                })
                fileToolBoxDiv.appendChild(uploadBtn);

                let uploadBtnContent = document.createElement("div");
                uploadBtn.appendChild(uploadBtnContent);

                let uploadBtnIcon = document.createElement("i");
                uploadBtnIcon.classList.add("fas", "fa-upload", "me-2");
                uploadBtnContent.appendChild(uploadBtnIcon);

                let uploadBtnText = document.createTextNode("Upload new file");
                uploadBtnContent.appendChild(uploadBtnText);
            }
        }
    }

    const addNewFile = async (fileInputID, uncompressedFile, multiple) => {
        let compressedFile = await service.compressImage(uncompressedFile);
        let response = await service.uploadFile(-1, uncompressedFile.name, compressedFile, "cfile")
        if(existingContent[fileInputID] === null) {
            existingContent[fileInputID] = [];
        }
        existingContent[fileInputID].push({
            file_id: response.file_id
        });
        await disableAndUpdateFileUploadSections([{
            id: fileInputID,
            files: existingContent[fileInputID],
            multiple: multiple
        }])
    }

    const removeFile = (fileInputID, file_id, multiple) => {
        service.removeFile(file_id).then((response) => {
            existingContent[fileInputID] = existingContent[fileInputID].filter(f => f.file_id !== file_id)
            disableAndUpdateFileUploadSections([{
                id: fileInputID,
                files: existingContent[fileInputID],
                multiple: multiple
            }])
        });
    }

    const getFilePath = async (file_id) => {
        let response = await fetch(model_root + 'shared/files/load_file.php?id=' + file_id, {
            method: "GET"
        })
        let responseAsJson = await response.json();
        return responseAsJson.fpath;
    }

    const prepareDataForStorage = async (detail) => {
        let data = {};
        for (let [index, key] of Object.keys(detail).entries()) {
            if (key === "touched" || key === "valid") {
                continue;
            }
            if (fields[index].subtype === "boolean_checkbox") {
                // ganz, ganz komisches Verhalten... Workaround um einen einheitlichen boolean Wert zu erhalten
                if (Array.isArray(detail[key])) {
                    data[key] = (detail[key].length !== 0);
                } else {
                    data[key] = (detail[key] !== null)
                }
            } else if (Array.isArray(detail[key])) {
                data[key] = [];
                for (let [index, item] of detail[key].entries()) {
                    if (item instanceof File) {
                        let file = await service.compressImage(item);
                        let response = await service.uploadFile(-1, file.name, file, "cfile")
                        data[key][index] = {
                            file_id: response.file_id
                        };
                    }
                }
            } else if (existingContent !== undefined && existingContent[key] && fields[index].type === "file") {
                data[key] = existingContent[key];
            } else {
                data[key] = detail[key];
            }
        }
        return data;
    }
    const onSubmit = async ({detail}) => {
        let data = await prepareDataForStorage(detail);
        let dataStringified = JSON.stringify(data)

        const formData = new FormData();
        if (existingContent === undefined) {
            formData.append("ccmenu", mid);
        } else {
            formData.append("ccid", existingContent.id);
        }
        formData.append("ccdata", dataStringified);

        let url = model_root + 'admin/contents/upload_custom_content.php';
        if (existingContent !== undefined) {
            url = model_root + 'admin/contents/update_custom_content.php'
        }

        fetch(url, {
            method: "POST",
            body: formData
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    toasts.success('Inhalte erfolgreich übernommen', 'Das Fenster schließt sich automatisch.', {duration: 3000});
                    setTimeout(close, 3000)
                } else {
                    toasts.error('Ein Fehler ist aufgetreten', msg, {duration: 10000});
                }
            });
    };
</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data}/>
</ToastContainer>


{#if loaded}
    <Formly {fields} {form_name} on:submit={onSubmit}
            btnSubmit={{
                text: 'Eingaben übernehmen',
                classes: ['btn', 'btn-primary', 'mt-2']
            }}
            btnReset={{
                text: 'Eingaben löschen',
                classes: ['btn', 'btn-secondary', 'mt-2']
            }}
    />
{/if}

<style>
    :global(.invalid-feedback) {
        display: block;
        margin-bottom: 8px;
        margin-top: -3px;
    }

    :global(div.list-files .file .img img) {
        width: 200px;
    }

    :global(.ccfile-list-item-img) {
        height: 80px;
        background-size: cover;
    }
</style>
